export default {
  agreeTitle: 'Acordo sobre o uso do serviço de marketing "acbuy Alliance" no site acbuy',
  agreementText: `Bem-vindo ao registro no site acbuy e uso de seu serviço de marketing "acbuy Alliance". Este acordo é estabelecido entre o parceiro "acbuy Alliance" (doravante referido como "Parte B") e acbuy (doravante referido como "Parte A") (incluindo, mas não limitado a www.acbuy.com, aplicativo móvel acbuy, etc., doravante referido como "Site da Parte A") sobre questões relacionadas ao serviço de marketing "acbuy Alliance". Antes de usar o serviço de marketing "acbuy Alliance" do site acbuy, a Parte B deve ler cuidadosamente todo o conteúdo deste acordo, especialmente as partes em negrito. Clicar no botão "Li e concordo" significa que a Parte B aceitou e concorda em cumprir as disposições deste acordo. Este acordo constitui um acordo entre a Parte B e acbuy e tem força legal. acbuy tem o direito de modificar unilateralmente os termos deste acordo de acordo com as necessidades do negócio. Se houver modificações, acbuy publicará imediatamente o conteúdo modificado no site da Parte A. Se a Parte B não concordar com as modificações do texto deste acordo, deve parar imediatamente de usar o serviço de marketing do canal "acbuy Alliance", caso contrário, será considerado que a Parte B concorda com as modificações do texto deste acordo.
Artigo 1 Definições 1. Consumidor: Refere-se ao membro acbuy que acessa o site da Parte A para registro`,
  dashboard: 'Painel',
  hi: 'Olá, ',
  inviteFriends: 'Convidar amigos',
  inviteFriendsTips:
    'Convide amigos para se juntarem ao acbuy e ganhe mais dinheiro! Quanto mais você convidar, mais você ganha, sem limite.',
  inviteFriendsTips1: 'Convide 3 contas ativas para obter direitos de venda e ganhar comissões.',
  totalInvite: 'Total de usuários convidados',
  myTeam: 'Minha equipe',
  extractMoney: 'Comissão liquidada',
  noExtractMoney: 'Comissão não liquidada',
  inviteTitle: 'Convidar meus amigos',
  copyCode: 'Copiar código de convite',
  poster: 'Pôster exclusivo',
  myLevel: 'Meus privilégios',
  youLevel: 'Seu nível atual',
  commissionRate: 'Taxa de comissão',
  experienceValue: 'Valor de experiência({num}/{total})',
  levelDesc: 'Descrição do nível',
  invite: 'Convidar',
  revenueDetails: 'Detalhes do convite',
  registerTime: 'Hora de registro',
  inviteType: 'Relação de associação',
  userMail: 'E-mail do usuário',
  bonus: 'Bônus',
  myBonus: 'Meu bônus',
  myBalance: 'Meu saldo',
  applyWithdraw: 'Solicitar saque',
  withdrawTips:
    'Dica: Como o saque envolve taxas de transação, recomenda-se que o valor do saque seja superior a ¥500.00',
  bank: 'Banco',
  paypalAccount: 'Conta PayPal',
  bankAccount: 'Conta bancária',
  bankName: 'Nome do banco',
  withdrawAmount: 'Valor do saque({unit})',
  bonusDetail: 'Detalhes do bônus',
  directCommission: 'Detalhes da comissão direta',
  indirectCommission: 'Detalhes da comissão indireta',
  tradeTime: 'Hora da transação',
  packNo: 'Número do pacote',
  actCommission: 'Comissão',
  settlementTime: 'Hora da liquidação',
  levelName: 'Nível de promoção',
  packStatus: 'Status do pacote',
  directExplain: 'Taxa de comissão',
  indirectExplain: 'Comissão indireta',
  experienceExplain: 'Valor de experiência',
  withdrawRecord: 'Registro de saque',
  withdrawTime: 'Hora do saque',
  serialNo: 'Número de série',
  withdrawStatus: 'Status do saque',
  team: 'Equipe',
  levelUp: 'Subir de nível',
  teamInfo: 'Informações da equipe',
  teamNum: 'Número de usuários da equipe',
  monthCommission: 'Comissão estimada deste mês',
  accCommission: 'Comissão liquidada acumulada',
  teamMember: 'Membros da equipe',
  promotedMember: 'Membro promovido',
  invitationTime: 'Hora do convite',
  inviter: 'Convidador',
  promotionTime: 'Hora da promoção',
  IBAN: 'IBAN',
  swiftCode: 'Código Swift',
  bankAddress: 'Endereço do banco',
  setting: 'Configurações',
  profile: 'Perfil',
  withdrawMethod: 'Método de saque',
  myPrerogative: 'Meus privilégios',
  verifyEmail: 'Verifique seu e-mail',
  sendCodeTips:
    'Enviamos um código de verificação para <strong>{email}</strong>. Por favor, insira o código de verificação abaixo para verificar.',
  noGetEmail: 'Não recebeu o e-mail?',
  codeErrorTips: 'Código de verificação incorreto, por favor, tente novamente',
  resendTime: 'Reenviar código de verificação ({time} segundos)',
  or: 'ou',
  contactService: 'Contatar atendimento online',
  addMethod: 'Adicionar método de saque',
  editMethod: 'Editar método de saque',
  rePaypalAccount: 'Reinserir conta PayPal',
  directInvite: 'Convite direto',
  indirectInvite: 'Convite indireto',
  noSameAccount: 'Conta e conta de confirmação não correspondem',
  noAddWithdrawMethod: 'Você não adicionou método de saque',
  statusEnum: {
    0: 'Aguardando distribuição',
    1: 'Em distribuição',
    2: 'Distribuição bem-sucedida',
    3: 'Falha na distribuição',
    4: 'Saque cancelado',
  },
  userDetail: 'Detalhes do usuário',
  balance: 'Saldo da conta',
  withdrawMax: 'O valor do saque deve ser maior que ¥500.00',
  addPaypalAccount: 'Adicionar conta Paypal',
  addBankAccount: 'Adicionar conta bancária',
  noPaypalAccount: 'Sem conta Paypal',
  noBankAccount: 'Sem conta bancária',
  estimated: 'Entregue',
  notEstimated: 'Não entregue',
  actual: 'Real',
  estiamte: 'Estimado',
  directRealtion: 'Relação direta',
  indirectRealtion: 'Relação indireta',
  experienceValueText: 'Valor de experiência',
  relatedParcel: 'Pacote relacionado',
  empiricalValue: 'Valor de experiência',
  acquiringTime: 'Hora de obtenção',
  relatedEmail: 'E-mail associado',
  relatedUsers: 'Usuários associados',
  balanceDetail: 'Detalhes do saldo',
  commissionDetail: 'Detalhes da comissão',
  details: 'Detalhes',
  question1:
    'Após o usuário convidado concluir o envio do pacote, seu status será atualizado para "Ativado"',
  question2: 'O pedido foi concluído e a comissão foi transferida para sua conta de saldo',
  question3:
    'Comissão de todos os pedidos "não confirmados". Os pedidos serão verificados em 30-60 dias, e então a comissão será transferida para sua conta de saldo',
  activatedUser: 'Usuário ativado',
  bankTip: 'Taxa de saque: 2% do valor do saque',
  selectWithdrawMethod: 'Selecionar método de saque',
  currentWithdrawAmount: 'Valor disponível para saque atual',
  modify: 'Modificar',
  bonusBalance: 'Saldo de comissão disponível',
  balanceTips1: '1. Pagamento de bônus liquidados do mês anterior no dia 1 de cada mês (UTC+8)',
  balanceTips2:
    '2. Os dias 1 (UTC+8) a 10 (UTC+8) de cada mês são os dias de saque. Você pode escolher sacar entre os dias 1 (UTC+8) e 11 (UTC+8). Transferiremos os fundos para você antes do dia 20 (UTC+8). Após a transferência, notificaremos você por e-mail sobre o resultado da transferência. Ao mesmo tempo, você pode visualizar informações relacionadas à transferência no registro de saque.',
  income: 'Receita',
  expenditure: 'Despesa',
  commissionSettlement: 'Liquidação de comissão',
  commissionWithdrawal: 'Saque de comissão',
  withdrawalCancellation: 'Cancelamento de saque',
  activeStatus: 'Status de ativação',
  settlePackageNum: 'Número de pacotes',
  activeTime: 'Hora de ativação',
  orderTime: 'Hora de envio do pacote',
  orderUser: 'Usuário que enviou o pacote',
  actualFreight: 'Frete pago',
  estimatedCommission: 'Comissão estimada',
  withdrawAccount: 'Conta de saque',
  withdrawType: 'Tipo de saque',
  withdrawTypeEnum: {
    2: 'Saque para saldo',
    0: 'Saque para cartão bancário',
  },
  applyTime: 'Hora da solicitação',
  withdrawStatusEnum: {
    0: 'Em revisão',
    1: 'Em saque',
    2: 'Saque bem-sucedido',
    3: 'Saque recusado',
    4: 'Saque cancelado',
  },
  bankEndNumber: 'Últimos dígitos do cartão bancário',
  cancelWithdraw: 'Cancelar saque',
  withdrawalDetails: 'Detalhes do saque',
  transferVoucher: 'Comprovante de transferência',
  cancelWithdrawConfirm: 'Confirmar cancelamento de saque',
  delPackageHint:
    'Após confirmar o cancelamento do saque, o valor correspondente do saque será reembolsado ao seu saldo de comissão',
  withdrawTip:
    'Os dias 1 (UTC+8) a 10 (UTC+8) de cada mês são os dias de saque. Você pode escolher sacar entre os dias 1 (UTC+8) e 10 (UTC+8)',
  hasLogOff: 'Cancelado',
}
